import { V2CircularProgress } from "@stacklet/ui";

import { BackdropFallback } from "./BackdropFallback";

export function CircularFallback() {
  return (
    <BackdropFallback>
      <V2CircularProgress size="xl" variant="inverted" />
    </BackdropFallback>
  );
}
